import React, { Component } from 'react';

//react-dom router
import { BrowserRouter, Route, Switch } from 'react-router-dom'

//home component
import HomeView from '../generic_components/view/HomeView';

//import cari page
import CariMainRouter from "../cari/js/views/CariMainRouter";

//invalid path
import InvalidRouteView from '../generic_components/view/InvalidRouteView';

//urls
import {
     home_pg_url, 
     cari_home_pg_url, 
} from "./static_routes";

class Router extends Component {
    
    render() { 
        return (  
            <BrowserRouter>
                <div>
                    <Switch>
                        <Route
                            component={CariMainRouter}
                        />
                    </Switch>
                </div>
            </BrowserRouter>
        );
    }
}

/*
Extension for more than one home page
<div>
    <Switch>
        <Route 
            exact
            path={home_pg_url} 
            component={HomeView} 
        />
        <Route 
            path={cari_home_pg_url} 
            component={CariMainRouter} 
        />

        <Route 
            component={InvalidRouteView}

    </Switch >
</div >
*/
export default Router;
